import {Injectable} from '@angular/core';
import {ApiContext, ApiService, PesAccountService, PesUser, PesUserService, PesUserUtils} from '@pes/ui';
import {Observable} from 'rxjs/Observable';
import {map} from 'rxjs/operators/map';


@Injectable()
export class UserService extends PesUserService {

    protected readonly DEFAULT_LANG_KEY: string = 'fr-FR';

    constructor(protected apiService: ApiService,
                protected context: ApiContext,
                protected account: PesAccountService) {
        super(apiService, context, account)
    }

    public create(user: any, notify: boolean = false): Observable<PesUser> {
        if (!user.login) {
            user.login = user.email;
        }
        user.langKey = this.DEFAULT_LANG_KEY
        return this.apiService.post(`${this.OLD_PATH}/create?notify=false`, user, {
            entityRef: user.entity && user.entity.reference !== this.context.entityRef ? user.entity.reference : null
        }).pipe(
            map(PesUserUtils.fromJSON)
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/config/provider/user.service.ts